// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rEDt","content":"styles_content__2yE02","row":"styles_row__27t9P","footer":"styles_footer__3r6jZ","phraseLength":"styles_phraseLength__1SiIp"};